<card-layout title="What happens next" icon="next_plan" [showProgressBar]="false">
   <p>A member of the Minster Law team will be reviewing your information. This is to ensure we have the information required to proceed. Once confirmed, they'll send you a form to sign.</p> 
   <p>This form is to notify the other side's insurance and is the last step in registering your claim.</p>
   <p>If the information you have provided indicates that your claim may be more complex or your injuries more serious than first thought, we may contact you for further information.</p>
 </card-layout>

